module.exports = __webpack_public_path__ + "static/media/twoThirdImageLeft.962e2da3.png";